import { create } from 'zustand';

export interface FilesAwarenessContext {
  module: 'files';
  fileId: number;
  fileName?: string;
  mimeType?: string | null;
  mode?: 'list' | 'preview' | 'edit';
  selectedText?: string;
  selectionRange?: { startLine: number; startColumn: number; endLine: number; endColumn: number };
}

interface FilesContextStore {
  context: FilesAwarenessContext | null;
  setFilesContext: (ctx: FilesAwarenessContext | null) => void;
  updateFilesContext: (patch: Partial<FilesAwarenessContext>) => void;
  setSelection: (
    sel: { selectedText?: string; selectionRange?: FilesAwarenessContext['selectionRange'] } | null,
  ) => void;
  clearFilesContext: () => void;
}

/**
 * Global store for files-module awareness. Populated by FilesPage / FilePreview /
 * FileEditorPage so that AIChatWidget can inject the active file context into
 * `ai:chat` payloads.
 */
export const useFilesContextStore = create<FilesContextStore>((set, get) => ({
  context: null,
  setFilesContext: (ctx) => set({ context: ctx }),
  updateFilesContext: (patch) => {
    const cur = get().context;
    if (!cur) return;
    set({ context: { ...cur, ...patch } });
  },
  setSelection: (sel) => {
    const cur = get().context;
    if (!cur) return;
    if (!sel) {
      const { selectedText: _t, selectionRange: _r, ...rest } = cur;
      void _t; void _r;
      set({ context: rest as FilesAwarenessContext });
      return;
    }
    set({ context: { ...cur, selectedText: sel.selectedText, selectionRange: sel.selectionRange } });
  },
  clearFilesContext: () => set({ context: null }),
}));
